import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { FormControlLabel, Radio } from '@mui/material';

export default function AttachMenu(props) {

    const { label, options, selectedValue = '', onselect = false, idKey = '', dataKey = '' } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (val, prevValue) => {
        onselect && onselect(prevValue ? {} : val)
        setAnchorEl(null);
    }
    return (
        <div className="menuRadio">
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{ color: '#fff' ,minWidth:0,padding:0}}
            >
                {label}
            </Button>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {options.map((val, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => handleSelect(val, selectedValue?.[idKey] === val?.[idKey])}
                        selected={selectedValue?.[idKey] === val?.[idKey]}
                    >
                        <FormControlLabel value={val?.AttachmentTag} control={<Radio checked={selectedValue?.[idKey] === val?.[idKey]} />} label={val?.[dataKey]} />
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
